import { render } from "./SuCompanyDetail.vue?vue&type=template&id=6713601d"
import script from "./SuCompanyDetail.vue?vue&type=script&lang=js"
export * from "./SuCompanyDetail.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__